import { Box, Typography, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

/* ================= PRODUCT DATA ================= */
const productData = {
  coltcs: {
    title: "Condenser Online Tube Cleaning System",
    img: "/Web4.jpg",
    description: `The Condenser Online Tube Cleaning System (COLTCS) is intended to prevent the formation of various forms of fouling and scaling in the condenser tubes resulting consistent heat-transfer & unit output for longer time without shutdown of condenser tubes for cleaning. We have leading approvals with NTPC, BHEL, Toshiba, Siemens, Alstom, etc. and supplied the system at various power plants.`,
  },

  "debris-filters": {
    title: "Debris Filters & Automatic Filters",
    img: "/Web5.jpg",
    description: `This is essential to prevent macro-fouling from debris in cooling water circuits. Wherever Marco fouling occurs, such as in the heat exchanger, condenser, or cooling tower, and protection of downstream equipment becomes essential, debris filters are vital components to use.`,
  },

  "sponge-balls": {
    title: "Sponge Rubber Balls",
    img: "/spb.jpg",
    description: ` The Sponge Rubber balls are used for condenser tube cleaning system. The complete range of Ball sizes operating from 15 mm to 45 mm diameter available in soft, medium, hard and extra hard to clear all type of deposits. Balls are available in type B (pumice), Type G1 (granulates mixtures) type G2 (granulates surface), abrasive (corundum) with type R (ring) and type 1 (total).At least equal performance demonstrated at various site against International make Condenser Tube Cleaning Systems. The balls can be made available within 4 weeks of the receipt of order.

`,
  },

  strainers: {
    title: "Low-Pressure Drop Strainers",
    img: "/Strainer (2).png",
    description: `Low-pressure drop (LPD) Y, T, Basket, Duplex strainers consist of a large screen. It has no bridge wall, enabling smooth fluid flow with low turbulence and reduced velocity, thereby minimizing pressure drop.

Our low-pressure drop strainers are tested for rated flow and have been proven and certified in labs as well as at site for a full range of flow versus pressure drop. We have been a preferred choice for pump OEMs like KSB and end-users like NTPC for several years. Strainer  Techinal  Group  specializes  in  design  and  manufacture  of  Filters  and  Strainers  for protection  services.`,
    items: [
      {
        title: "Y-Type Strainers",
        image: "/y-type.png",
        description:
          "A  range  of  Simple strainers for installation in systems with very low levels of debris.  Y strainers have in line connections and simple cylindrical screen with access through screwed or bolted cover.",
      },
      {
        title: "T-Type Strainers",
        image: "/t-type.png",
        description:
          "These strainers are left installed as an additional permanent safeguard against carry over of Debris. Units may be flanged or welded into the line and the screen is extracted through the branch opening. Each unit is provided with a flanged cover.",
      },
      {
        title: " Duplex Strainer",
        image: "/Duplex Large.png",
        description:
          "These  are  designed to complement the simplex filters but allows the cleaning  and replacement of inserts to be carried out without an interruption to the flow through the filter. Fixed stops are provided to indicate which baskets is in use. A projecting flange from the change over handle, guards the cover of the basket in use, making it impossible to remove inadvertently.",
      },
     
      {
        title: "Fabricated Simplex Strainer",
        image: "/Basket.png",
        description:
          "Welded steel single basket filter unit Custom Engineered to meet unusual applications, Performance or dimensional requirements. Design allows for straining of low specific gravity fluids, backwash and blow down features, high pressure and high temperature application. This can be performed with single or multiple",
      },
      {
        title: "Temporary Conical Strainer",
        image: "/Conical.png",
        description:
          "Simple  strainers for temporary installation during the commissioning, or start- up phase of system, to protect equipment from damages caused by the passage of construction/Fabrication debris. This type is specifically designed for location between flanges, where pipe work can be split to extract the when commissioning is complete.",
      },
      
    ],
  },

  "pipeline-division": {
    title: "Pipeline Division",
    img: "/Web-7.jpg",
    description: (
      <>
        <Typography sx={{ fontSize: "20px", lineHeight: 1.5, color: "#444", mb: 3 }}>
          As part of the International Safety Guidelines and specific Integrity Safety
          Management Guidelines, pipelines need to be regularly cleaned and monitored
          for any suspected debris.
        </Typography>

        <Typography sx={{ fontSize: "20px", lineHeight: 1.5, color: "#444", mb: 4 }}>
          Multitex offers launchers and receivers along with flow / barred tees and pig
          signalers with automation and interlocks, which form part of the safety
          operational guidelines while cleaning the cross-country pipelines, or flow
          lines.
        </Typography>

        <Typography sx={{ fontSize: "20px", lineHeight: 1.5, color: "#444" }}>
          SCRAPPERS TRAPS BI-DIRECTIONAL WITH AUTOMATION SAFETY{" "}
          <strong>SYSTEMS:</strong>{" "}
          We manufacture scrapper traps of all sizes and pressure ratings following
          ASME, TUV, API, and other application-based codes.
        </Typography>
      </>
    ),
  },

  "pressure-vessels": {
    title: "Pressure Vessels",
    img: "/Pressure Vessel.JPG",
    description:
      "We build the Pressure Vessels for our own in-house process package requirements and also for Process Licensors in small and large sizes and various materials including exotic materials and cladding materials. As part of our offering, we do carry out FEA analysis and support critical mechanical design for special cases, including cyclic cases like in PSA Absorber and Adsorbers.",
  },

  signalers: {
    title: "Pig Signalers",
    img: "/Pig_signaller.png",
    description:
      "As the name suggests, it is used to signal and update the location of the cleaning device in the pipeline. It indicates that the device has left and arrived in the receiver or has crossed a certain point in the pipeline.",
  },

  "quick-opening": {
    title: "Quick Opening Closure",
    img: "/quick closer.jpg",
    description:
      "The Multitex system provides secure and easier access to process pressure vessels. The SEG-LOK system allows opening a closure, horizontal or vertical, in just few minutes without any special tools, using a single operator. ",
  },
};
  
/* ==================== PRODUCT PAGE ==================== */
export default function ProductDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData[id];

  if (!product) {
    return (
      <Typography component="h2" sx={{ p: 10 }}>
        Product Not Found
      </Typography>
    );
  }

  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: "250px" }, py: 8 }}>
      
      {/* TITLE */}
      <Typography
        component="h1"
        sx={{
          fontSize: "20px",     // ✅ fixed
          fontWeight: 800,
          textAlign: "center",
          mb: 6,
          color: "#2d2075",
        }}
      >
        {product.title}
      </Typography>

      <Grid container spacing={6}>
        {/* IMAGE */}
        {product.img && (
          <Grid item xs={12} md={5}>
            <img
              src={product.img}
              alt={product.title}
              style={{ width: "100%", display: "block" }}
            />
          </Grid>
        )}

        {/* DESCRIPTION */}
        <Grid item xs={12} md={7}>
          <Typography
            sx={{
              fontSize: "20px",   
              lineHeight: 1.6,
              color: "#333",
              whiteSpace: "pre-line",
            }}
          >
            {product.description}
          </Typography>
        </Grid>
      </Grid>

  

{/* ================= STRAINER SECTION ================= */}
{Array.isArray(product.items) && product.items.length > 0 && (
  <Box component="section" aria-labelledby="strainers-title" sx={{ mt: 10 }}>

    {/* DIVIDER */}
    <Box
      sx={{
        width: "100%",
        height: "2px",
        backgroundColor: "#2d2075",
        opacity: 0.25,
        mb: 8,
      }}
    />

    <Typography id="strainers-title" component="h2" sx={{ display: "none" }}>
      Strainer Products
    </Typography>

    {product.items.map((item, index) => {
      const isImageLeft = index % 2 === 0; 

      return (
        <Grid
          container
          key={index}
          spacing={6}
          alignItems="center"
          direction={{ xs: "column", md: isImageLeft ? "row" : "row-reverse" }}
          sx={{ mb: 10 }}
        >
          {/* IMAGE */}
          <Grid item xs={12} md={5}>
            <Box
              component="figure"
              sx={{
                width: "100%",
                height: { xs: 260, md: 320 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                m: 0,
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Box>
          </Grid>

          {/* TEXT */}
          <Grid item xs={12} md={7}>
            <Typography
              component="h3"
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#2d2075",
                mb: 2,
              }}
            >
              {item.title}
            </Typography>

            <Typography
              component="p"
              sx={{
                fontSize: "18px",
                lineHeight: 1.7,
                color: "#333",
                maxWidth: "600px",
              }}
            >
              {item.description}
            </Typography>
          </Grid>
        </Grid>
      );
    })}
  </Box>
)}

      {/* ================= BACK BUTTON ================= */}
      <Box sx={{ textAlign: "center", mt: 8 }}>
        <Button
          variant="contained"
          onClick={() => {
            navigate("/");
            setTimeout(() => {
              document
                .getElementById("products")
                ?.scrollIntoView({ behavior: "smooth" });
            }, 300);
          }}
          sx={{
            background: "#2d2075",
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            "&:hover": { background: "#2d2075" },
          }}
        >
          ← Back to Products
        </Button>
        </Box>
    </Box>
  );
}

